// eslint-disable-next-line no-unused-vars
import { AxiosResponse } from 'axios';

import axiosInstance from './axiosInstance';

/**
 * @typedef {Object} ParamsUpdateCollectorAccountAlias
 * @property {String | Number} id - Id de la cuenta recaudadora
 * @property {String} alias - Nuevo alias bancario
 */

/**
 * Actualiza el alias de una cuenta recaudadora
 * @param {ParamsUpdateCollectorAccountAlias} params
 * @returns {Promise<AxiosResponse>}
 */
const updateCollectorAccountAlias = (params) => {
  const { id, alias } = params;

  return axiosInstance.patch(
    `/internal/admin/collector_accounts/${id}/update_alias`,
    { alias },
  );
};

export default updateCollectorAccountAlias;
